import { ServiceContainer } from "./modularity/serviceContainer";
import { MakeBridgeServiceDefinition } from "./services/cli/bridgeService";
const DefaultPort = 4400;
/**
 * Creates a headless {@link ServiceContainer} that hosts a bridge service.
 *
 * The returned token owns the container. Dispose it to tear down the bridge.
 *
 * @param options Optional configuration for the bridge.
 * @returns A {@link ModularBridgeToken} that owns the container.
 * @experimental
 * @internal
 */
export function MakeModularBridge(options) {
    const serviceContainer = new ServiceContainer("ModularBridgeContainer");
    const bridgeDefinition = MakeBridgeServiceDefinition({
        port: options?.port ?? DefaultPort,
        get name() {
            return options?.name ?? (typeof document !== "undefined" ? document.title : "Babylon.js Scene");
        },
        autoEnable: options?.autoEnable ?? true,
    });
    const allDefinitions = [bridgeDefinition];
    if (options?.serviceDefinitions) {
        allDefinitions.push(...options.serviceDefinitions);
    }
    serviceContainer.addServices(...allDefinitions);
    let disposed = false;
    return {
        get serviceContainer() {
            return serviceContainer;
        },
        get isDisposed() {
            return disposed;
        },
        dispose() {
            disposed = true;
            serviceContainer.dispose();
        },
    };
}
//# sourceMappingURL=modularBridge.js.map